import { getToken, getUserInfo, setUserInfo, 
        removeUserInfo, deleteToken, deleteReshToken,
        setCer, getCer, deleteCer 
  } from '@/utils/auth'
import { login, LoginOut } from '@/http/api/common'
import {GetMyCouponGroupListQueryPage, GetUserInfo} from '@/http/api/user'
const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: getUserInfo(),
    isCertified: getCer(),
    toolPagePath:'',
    coupon:[]
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
    // Vue.set(state.userInfo, 'userInfo', userInfo)
  },
  SET_ISCERTIFIED: (state, isCertified) => {
    state.isCertified = isCertified
  },
  SET_TOOLPAGEPATH: (state, toolPagePath) => {
    state.toolPagePath = toolPagePath
  },
  SET_COUPON: (state, coupon) => {
    state.coupon = coupon
  }
}

const actions = {
  async login({ commit }, data) {
    const response = await login(data)
    console.log(response,"response")
    if (response.statusCode === 200) {
      if (response.extras.apiStatusCode === 1000) {
        // 非机构用户记录认证信息
        let orgIdStr = ''
        if(response.data.isOrg !== 1) {
          let authorOFA = { ibo:response.data.isBindOrg, icf:response.data.isCertified, iba:response.data.isBindAuthor }
          commit('SET_ISCERTIFIED', authorOFA)
          setCer(JSON.stringify(authorOFA))  
        } 
        const userInfo = { trueName: response.data.trueName , isOrg: response.data.isOrg, photoPath: response.data.photoPath, pId: response.data.id, phone: response.data.mobileNo, memberList: response.data.memberList }
        commit('SET_USERINFO', userInfo)
        setUserInfo(userInfo)
        return response
      } else {
        return response
      }
    } else {
      return response
    }
  },
  async logout({ commit, state }) {
    const response = await LoginOut()
    if (response.statusCode === 200) {
      if (response.extras.apiStatusCode === 1000) {
        removeUserInfo()
        commit('SET_USERINFO', '')
        deleteToken()
        commit('SET_TOKEN', '')
        deleteReshToken()
        commit('SET_ISCERTIFIED', '')
        deleteCer()
      }
      return response
    } else {
      return response
    }
  },
  async getCoupon({ commit,state }, data) { 
    const listObj = 
    {
      pageIndex: 1,
      pageSize: 10,
      deleteFlag: -1,
      isUse: 0, //是否使用（0 未使用 1 已使用 2 已过期）
      userId: state.userInfo.pId,
      //types: -1, //（1 论文检测  2 选题分析 3 专家咨询）      
    }
    const response = await GetMyCouponGroupListQueryPage({...data,...listObj})
    if (response.statusCode === 200) {
      if (response.extras.apiStatusCode === 1000) {
        const coupon = response.data.items.length>0?response.data.items:[{count:0}]
        commit('SET_COUPON', coupon)
        return coupon
      }
    }
    else {
      return state.coupon
    }
  },
  async setMemberList({ commit, state }, data) {
    try {
      let info = await GetUserInfo();
      let userInfo = getUserInfo();
      userInfo.memberList = info.data.memberList;
      commit('SET_USERINFO', userInfo)
      setUserInfo(userInfo);
    } catch (err){
      console.error("getUserInfo:" + err);
    }
  },
}
// 判断认证步骤
const checkStep = function(data){
  let step = '0'
  if(data.isBindOrg === 0){ // 绑定机构
    step = '0'
    return step
  } else if(data.isCertified === 0){ // 实名认证
    step = '1'
    return step 
  } else if(data.isBindAuthor === 0){ // 绑定作者
    step = '2'
    return step 
  } else if(data.isBindOver === 0){ // 确认完成
    step = '3'
    return step 
  } else {
    step = '4'
    return step 
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}

